import React from 'react';

class PluginErrorBoundary extends React.Component {
  static getDerivedStateFromError(error) {
    return { error };
  }
  state = { error: void 0 };
  handleErrorReset = () => {
    this.setState({ error: void 0 });
  };
  render() {
    const { error } = this.state;
    const { app, plugin } = this.props;
    const { ErrorBoundaryFallback } = app.getComponents();
    if (error) {
      return /* @__PURE__ */ React.createElement(
        ErrorBoundaryFallback,
        {
          error,
          resetError: this.handleErrorReset,
          plugin
        }
      );
    }
    return this.props.children;
  }
}

export { PluginErrorBoundary };
//# sourceMappingURL=PluginErrorBoundary.esm.js.map
